import { Nullable } from '@/models/common'

export enum LsGlobalKeys {
  AUTH = 'auth',
  CURRENT_MODULE = 'currentModule',
  LAST_ROUTE = 'lastRoute',
}

export const lsGet = (key: LsGlobalKeys): string | null =>
  localStorage.getItem(key)

export const lsSave = (
  key: LsGlobalKeys,
  // eslint-disable-next-line
  payload?: Nullable<Record<string, any> | string | any[]>
) => {
  if (!payload) {
    return
  }

  localStorage.setItem(key, JSON.stringify(payload))
}

export const lsRemove = (key: LsGlobalKeys) => localStorage.removeItem(key)

export const lsHas = (key: LsGlobalKeys) => lsGet(key) !== null
